// src/tracking/linkedin.js

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}

async function waitForLintrk(timeoutMs = 5000) {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    if (typeof window !== "undefined" && typeof window.lintrk === "function") return true;
    await sleep(100);
  }
  return false;
}

/**
 * Fires a LinkedIn event-specific conversion.
 * conversionId: number (from LinkedIn conversion setup UI)
 */
export async function trackLinkedInConversion(conversionId) {
  try {
    // If ID isn't configured yet, do nothing.
    if (!conversionId) return;

    const ok = await waitForLintrk(5000);
    if (!ok) return; // fail silently

    const event_id =
      (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

    window.lintrk("track", {
      conversion_id: conversionId,
      event_id, // optional, helpful if you ever add server-side CAPI + dedupe
    });
  } catch {
    // intentionally ignore tracking failures
  }
}
